import { Component, ChangeDetectionStrategy, Input } from '@angular/core';
@Component({
  selector: 'td-wb-learn-duration',
  templateUrl: './learn-duration.component.html',
  styleUrls: ['./learn-duration.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class LearnDurationComponent {
  @Input() duration: number;
  @Input() timeRemaining: number;
  @Input() isCourse: boolean = false;

  inProgress(): boolean {
    return this.timeRemaining !== undefined && this.timeRemaining !== 0;
  }
}
